import type { Color } from "@clovis/server/src/app/config/colors/colors";
import { colorToHexValues } from "@clovis/server/src/app/config/colors/colors";
import { PencilIcon } from "@heroicons/react/outline";
import * as React from "react";
import { useIsOffline } from "~/config/offline-storage/useIsOffline.hook";
import { Dot } from "~/design-system/Badge";
import { Box } from "~/design-system/Box";
import { Button } from "~/design-system/Button";
import { Column, Columns } from "~/design-system/Columns";
import { Text } from "~/design-system/Text";
import type { CategoriesList_ItemFragment } from "./UpdateCategoryForm/UpdateCategoryForm.graphql";

type InfosProps = {
  category: CategoriesList_ItemFragment;
  onEditClick: () => void;
};

function Infos(props: InfosProps) {
  const color = colorToHexValues.get(props.category.color as Color)!.base;
  const isOffline = useIsOffline();

  return (
    <Columns space="small">
      <Column>
        <Box display="flex" alignItems="center" height="full">
          <Dot size="large" css={{ color }} />
          <Text css={{ color }}>{props.category.name}</Text>
        </Box>
      </Column>
      <Column width="content">
        <Button
          type="button"
          variant="transparent"
          circular
          onClick={props.onEditClick}
          dataClovisActionId="org-project-categories-edit"
          disabled={isOffline}
        >
          <PencilIcon />
        </Button>
      </Column>
    </Columns>
  );
}

export { Infos };
